export default __webpack_public_path__ + "static/media/About_1.505273c5.png";